import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { createStyles, Typography, TypographyProps } from '@material-ui/core';
import classNames from 'classnames';

const useStyles = makeStyles((theme) => createStyles({
	root: {
		fontSize: '1.125rem',
		fontWeight: 600,
		marginLeft: theme.spacing(1),
		textAlign: 'center',
	},
}));

const AlertHeaderNote: React.FC<TypographyProps> = ({ children, className, ...props }) => {
	const classes = useStyles();

	return (
		<Typography
			variant="h2"
			className={classNames(classes.root, className)}
			{...props}
		>
			{children}
		</Typography>
	);
};

export default AlertHeaderNote;
